/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EventoServer, WebRequest } from '@cgn/framework-ui-components/v1';
import Conversazione from './Conversazione';
import { withEventiServer } from '../../Shared/EventiServer/EventiServerContext';
import { messaggiServerEnum } from '../../Exports/iframeComunication';

class Quesito extends Component {
  eventiServerSubscriptions = [];

  state = {
    pratica: null,
  };

  componentDidMount() {
    const { eventiServerContext } = this.props;

    this.mounted = true;

    this.eventiServerSubscriptions = [
      eventiServerContext.subscribe(messaggiServerEnum.RispostaInviata, () => this.mounted && this.caricaPratica(this.props.idQuesito)),
      eventiServerContext.subscribe(messaggiServerEnum.PrerispostaInviata, () => this.mounted && this.caricaPratica(this.props.idQuesito)),
      eventiServerContext.subscribe(messaggiServerEnum.PraticaChiusa, this.onPraticaChiusa),
    ];

    this.caricaPratica(this.props.idQuesito);
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (this.props.idQuesito != next.idQuesito) {
      this.caricaPratica(next.idQuesito);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.eventiServerSubscriptions.forEach((unsubscribeFunc) => { unsubscribeFunc(); });
  }

  caricaPratica = (idQuesito) => {
    WebRequest.get(`${this.props.baseUrl}/Pratica/Pratica`, { codiceUfficio: this.props.ufficioSelezionato, idPratica: idQuesito }).then((res) => {
      this.setState({ pratica: res });
      if (res && !res.LettaDaUtente) {
        this.props.segnaPraticaComeLetta(this.props.idQuesito);
      }
    });
  };

  onPraticaChiusa = () => {
    this.props.segnaPraticaComeLetta(this.props.idQuesito, true);
  };

  render() {
    return (
      <div className="quesiti__col" style={{ height: this.props.baseUrl == '' ? 'calc(100vh - 105px)' : 'calc(100vh - 90px)' }}>
        {this.state.pratica && (
          <Conversazione
            urlHelpdesk={this.props.urlHelpdesk}
            profilo={this.props.profilo}
            disabilitaStampa={this.props.disabilitaStampa}
            baseUrl={this.props.baseUrl}
            ufficioSelezionato={this.props.ufficioSelezionato}
            stato={this.props.stato}
            ref={(c) => this.conversazione = c}
            pratica={this.state.pratica}
            onAggiornaPratica={() => this.caricaPratica(this.props.idQuesito)}
            onAggiornaListaQuesiti={this.props.caricaQuesiti}
            router={this.props.router}
          />
        )}
      </div>
    );
  }
}

Quesito.propTypes = {
  baseUrl: PropTypes.string,
  eventiServerContext: PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
  }).isRequired,
};

Quesito.defaultProps = {
  baseUrl: '',
};

export default withEventiServer(Quesito);
